import { render } from "./policysummary.vue?vue&type=template&id=e0534780&scoped=true"
import script from "./policysummary.vue?vue&type=script&lang=js"
export * from "./policysummary.vue?vue&type=script&lang=js"

import "./policysummary.vue?vue&type=style&index=0&id=e0534780&scoped=true&lang=css"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0534780"]])

export default __exports__